import Dashboard from '../../components/Finance/Dashboard.vue'
import Login from '../../components/Finance/Login.vue'
import InvestmentList from '../../components/Finance/InvestmentList.vue'
import InvestmentDetail from '../../components/Finance/InvestmentDetail.vue'
import InvestmentForm from '../../components/Finance/InvestmentForm.vue'
import PendingMovements from '../../components/Finance/PendingMovements.vue'
import Settings from '../../components/Finance/Settings.vue'
import BudgetView from '../../components/Finance/Budget/BudgetView.vue'
import SubscriptionList from '../../components/Finance/Subscriptions/SubscriptionList.vue'
import CompareInvestments from '../../components/Finance/Compare/CompareInvestments.vue'


export default [
    {
        path: '/login',
        name: 'finance_login',
        component: Login
    },
    {
        path: '/',
        component: Dashboard,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'finance_home',
                component: InvestmentList
            },
            {
                path: 'category/:id(\\d+)-:name?',
                name: 'finance_category',
                component: InvestmentList
            },
            {
                path: 'settings',
                name: 'finance_settings',
                component: Settings
            },
            {
                path: 'budget',
                name: 'finance_budget',
                component: BudgetView
            },
            {
                path: 'subscriptions',
                name: 'finance_subscriptions',
                component: SubscriptionList
            },
            {
                path: 'movements/pending',
                name: 'finance_pending_movements',
                component: PendingMovements
            },
            {
                path: 'investment/new',
                name: 'finance_investment_new',
                component: InvestmentForm
            },
            {
                path: 'investment/:id(\\d+)/edit',
                name: 'finance_investment_edit',
                component: InvestmentForm
            },
            {
                path: 'investment/:id(\\d+)-:name?',
                name: 'finance_investment_detail',
                component: InvestmentDetail
            },
            {
                path: 'compare',
                name: 'finance_compare',
                component: CompareInvestments
            }
        ]
    }
]
